import React from 'react';
import PropTypes from 'prop-types';
// Styles
import './Eyebrow.css';

const NAME = 'eyebrow';

function Eyebrow({
    size,
    children,
    classOverride,
    color
}) {
    const colorStyle = color ? {'color': color} : {};
    return (
        <h4 style={colorStyle} className={`${NAME} ${NAME}-${size} ${classOverride}`}>{children}</h4>
    )
}

Eyebrow.defaultProps = {
    classOverride: '',
    size: 'xs',
    color: null
};

Eyebrow.propTypes = {
    // Text
    children: PropTypes.string.isRequired,
    // Custom class
    classOverride: PropTypes.string,
    // Size
    size: PropTypes.string,
    // Font color
    color: PropTypes.string
};
export default Eyebrow;
